// extracted by mini-css-extract-plugin
export var avatarContainer = "_redotech-redo-web-lib-arbiter-components-avatars-avatar-avatar-container";
export var largeAvatarContainer = "_redotech-redo-web-lib-arbiter-components-avatars-avatar-large-avatar-container";
export var smallAvatarContainer = "_redotech-redo-web-lib-arbiter-components-avatars-avatar-small-avatar-container";